module.exports = __webpack_public_path__ + "adminatq.png";